import React from 'react'
import BaseImgBtn from './BaseImgBtn'

import img from 'assets/img/ic-text-disable.png'

const TextDisableBtn = (props: any) => {
  return <BaseImgBtn img={img} onClick={props.onClick} />
}

export default TextDisableBtn
